// core
import {Component, Input,} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';

// custom service
import {UtilsService} from '../../utils/utils.service';

@Component({
    selector: 'date-picker-input',
    templateUrl: './date-picker-input.component.html',
    styleUrls: ['./date-picker-input.component.scss'],
    standalone: false
})

export class DatePickerInput {

  @Input() formControlName: string;
  @Input() formGroup: UntypedFormGroup;
  @Input() clearInput: boolean = true;
  @Input() calendarIcon: boolean = true;

  private minDate = {
    year: 1940,
    month: 1,
    day: 1
  };

  private maxDate = {
    year: (new Date().getFullYear() - 18),
    month: 12,
    day: 31
  };

  constructor(
    private _utilsService: UtilsService,
  ) {
  }

  public getMinDate() {
    return this.minDate;
  }

  public getMaxDate() {
    return this.maxDate;
  }


  /**
   * @description Needed for IE11 when focus in & focus out formControlName is invalid
   */
  public focusOut() {
    if (this.formGroup.controls[this.formControlName] && !this.formGroup.controls[this.formControlName].value) {
      this.clearDateInput();
    }
  }

  /**
   * @author Incze Zoltan
   * @description On "X" button click the method will call the reset form input method from {UtilsService}
   */
  public clearDateInput() {
    this.formGroup = this._utilsService.resetDateFormControl(this.formGroup, this.formControlName);
  }
}
